import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CatHeading } from '@blocks-react/components/Heading';
import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
export const MyEquipmentFooterNote = ({ children, }) => {
    return (_jsxs(_Fragment, { children: [_jsx(CatIconWarningTriangle, { slot: "before", className: "me-1" }), _jsx(CatHeading, { variant: "label", children: children })] }));
};
